import { saveToStorage } from 'App/Helpers'
import {
	ADOPT_SESSION,
	LOGOUT,
	RESET_ORGANIZATION_STATE,
	SET_ACTIVE,
	SET_SESSION,
	SET_USER,
	SET_VERSION,
} from './mutation-types'
import Application from 'App/Foundation/Application'
import { LOGIN_TIMESTAMP_KEY } from '@/config/constants'
import intercom from '@/services/intercom'

/**
 * Export the Office Manager Vuex store plugin.
 *
 * @author Erik Galloway <egalloway@claruscare.com>
 */
export default store => {
	// Save the active partner id to local storage if it is not persisted
	if (store.state.partners.active && !localStorage.getItem('partner')) {
		saveToStorage('partner', store.state.partners.active)
	}

	// Keep every tab on the same session. Refresh tokens are single use, so a
	// tab must pick up the tokens another tab refreshed, and a logout in any
	// tab ends the session in all of them.
	window.addEventListener('storage', ({ key, newValue }) => {
		if (key !== 'session' || !store.state.auth.session?.access_token) {
			return
		}

		if (!newValue) {
			store.dispatch('auth/endSession', 'logged out in another tab')
			return
		}

		try {
			const session = JSON.parse(newValue)

			if (
				session?.access_token &&
				session.access_token !== store.state.auth.session.access_token
			) {
				store.commit(`auth/${ADOPT_SESSION}`, session)
			}
		} catch (e) {
			// Ignore a malformed value; the next refresh reads storage again.
		}
	})

	store.subscribe(({ type, payload }) => {
		switch (type) {
			case `auth/${LOGOUT}`:
				intercom.shutdown('auth-logout')
				Application.getInstance().emit('auth:logout')
				localStorage.removeItem('partner')
				localStorage.removeItem('session')
				localStorage.removeItem('user')
				localStorage.removeItem(LOGIN_TIMESTAMP_KEY)
				localStorage.removeItem('isCallNotesDropdownOpen')
				localStorage.removeItem('isHistoryDropdownOpen')

				store.dispatch('settings/stopOrganizationProfilePolling')
				store.commit(`settings/${RESET_ORGANIZATION_STATE}`)
				store.dispatch('calls/reset')
				store.dispatch('partners/reset')
				break

			case `auth/${SET_USER}`:
				saveToStorage('user', payload)
				if (
					payload?.id &&
					payload?.intercom_hash_web &&
					store.state.auth.session?.access_token
				) {
					intercom.bootIdentified(payload, 'auth-set-user')
				}
				break

			case `auth/${SET_SESSION}`:
				saveToStorage('session', payload)
				Application.getInstance().emit(
					'auth:token',
					store.state.auth.session.access_token
				)
				break

			case `auth/${ADOPT_SESSION}`:
				// Already in local storage; only Echo needs the new token.
				Application.getInstance().emit(
					'auth:token',
					store.state.auth.session.access_token
				)
				break

			case `auth/${SET_VERSION}`:
				saveToStorage('version', payload)
				break

			case `partners/${SET_ACTIVE}`:
				store.dispatch('settings/stopOrganizationProfilePolling')
				store.commit(`settings/${RESET_ORGANIZATION_STATE}`)
				store.dispatch('settings/syncOrganizationProfilePolling')
				store.dispatch('calls/reset')
				store.dispatch('pages/reset')
				store.dispatch('callTypes/reset')
				// store.dispatch('providers/reset')
				// store.dispatch('calendars/reset')
				store.dispatch('events/reset')
				store.dispatch('timeBlocks/reset')

				payload
					? saveToStorage('partner', payload)
					: localStorage.removeItem('partner')

				break
		}
	})
}
